import { ComponentProps, useState } from 'react';
import { noop } from 'lodash';
import { DrawerContent } from '@fiverr-private/overlay';

export const useDrawer = () => {
    const [isDrawerOpened, setIsDrawerOpened] = useState(false);
    const [children, setChildren] = useState<React.ReactNode>(null);
    const [size, setSize] = useState<ComponentProps<typeof DrawerContent>['size'] | undefined>('md');
    const [drawerCallbacks, setDrawerCallbacks] = useState<{ closeDrawerCallback: () => void }>({
        closeDrawerCallback: noop,
    });

    const openDrawer = () => {
        setIsDrawerOpened(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpened(false);
        setChildren(null);
        setSize('md');
        drawerCallbacks.closeDrawerCallback?.();
        setDrawerCallbacks({ closeDrawerCallback: noop });
    };

    return {
        setChildren,
        setSize,
        setDrawerCallbacks,
        openDrawer,
        isDrawerOpened,
        children,
        size,
        closeDrawer,
    };
};
